export const T = {
  en_GB: {
    ok: "OK",
    noData: "No data",
    noCurrency: "No currency",
    stale: "Stale",
    syncDisabled: "Sync off",
    syncFailing: "Failing",
    fxMissing: "No FX rate",
  },
  nb_NO: {
    ok: "OK",
    noData: "Ingen data",
    noCurrency: "Ingen valuta",
    stale: "Utdatert",
    syncDisabled: "Synk av",
    syncFailing: "Feiler",
    fxMissing: "Mangler valutakurs",
  },
} as const;
